module.exports = __webpack_public_path__ + "static/media/boat-img-16.d4d3a6f8.jpg";